// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b_kbrhAS1psHgAkRai0K{flex-direction:column;justify-content:center;align-items:flex-start;max-width:420px;display:flex}.K3xZejcElkVMsTTPUENE{justify-content:space-between;align-items:center;margin-bottom:44px;padding-top:3px;display:flex}.aOG_IoAQbgFhJ3RWspnA{flex-direction:column;align-self:flex-start;width:100%;max-width:220px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `b_kbrhAS1psHgAkRai0K`,
	"inboxSection": `K3xZejcElkVMsTTPUENE`,
	"selectWrapper": `aOG_IoAQbgFhJ3RWspnA`
};
export default ___CSS_LOADER_EXPORT___;
